export default {
    label: 'Vyberte si prosím službu',
    heading: 'Změna služby',
    maintenance: 'Objednání do servisu',
    tires: 'Pneumatiky',
    callingAction: 'Svolávací akce',
    chargingStation: 'Nabíjecí stanice'
}
